import { Node_Type } from "./../ricos-types";
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from "./../editor-common";
import { INSERT_FILE_BUTTON } from "./data-hooks";
import { handleFileUpload } from "./handle-file-upload";
import { InsertPluginIcon } from "./icons/insert-plugin-icon";
const toolbarsToAddIn = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE
];
const getAddButtons = (config, services) => {
  return [
    {
      id: Node_Type.FILE,
      label: INSERT_PLUGIN_BUTTONS.FILE,
      dataHook: INSERT_FILE_BUTTON,
      icon: InsertPluginIcon,
      tooltip: "FileUploadInsertButton_tooltip",
      toolbars: toolbarsToAddIn,
      command: ({ publicCommands }) => {
        handleFileUpload({ services, config, publicCommands });
        return true;
      },
      menuConfig: {
        tags: "UploadFile_plugin_search_tags"
      }
    }
  ];
};
export {
  getAddButtons,
  toolbarsToAddIn
};
//# sourceMappingURL=getAddButtons.js.map
